export type OrderShippingMessages = {
  //Titles
  shippingInformationTitle: string;

  //SubTitles
  customerNameSubTitle: string;

  //Labels
  customerAddressLabel: string;
  customerEmailLabel: string;
  customerCellphoneLabel: string;
  customerPhoneLabel: string;
  customerDocumentLabel: string;
};

export const ORDER_SHIPPING_MESSAGES: OrderShippingMessages = {
  //Titles
  shippingInformationTitle: "Informações de Envio",

  //SubTitles
  customerNameSubTitle: "Nome do cliente",

  //Labels
  customerAddressLabel: "Endereço",
  customerEmailLabel: "Email",
  customerCellphoneLabel: "Celular",
  customerPhoneLabel: "Telefone",
  customerDocumentLabel: "CPF/CNPJ ",
};
